import './styles.scss';

import React from 'react';

import classNames from 'classnames';

interface BacktestTableViewProps {
  title: string;
  filters: React.ReactNode;
  children: React.ReactNode;
  pagination?: React.ReactNode;
  className?: string;
}

export const BacktestTableView = ({
  title,
  filters,
  children,
  pagination,
  className,
}: BacktestTableViewProps) => {
  return (
    <section className={classNames('backtest-table-view', className)}>
      <div className="backtest-table-view__header">
        <h3>{title}</h3>
        <div className="backtest-table-view__filters">{filters}</div>
      </div>
      <div className="backtest-table-view__body">{children}</div>
      {pagination}
    </section>
  );
};
